// A fit segment as stars, the marks Sales Copilot shows for the same segment.
//
// Copilot's `EmojiScore` is the reference, character for character: ⭐ three
// times for Very Good down to once for Medium, and ❌ for Low. A customer who
// reads a lead in Copilot and then opens the model in Studio should see the
// same rating. The mapping is fixed to the tier, never derived from a score,
// or two leads in the same segment would carry different ratings.
import React from 'react';

import { Threshold } from '../../../models/ModelPerformances';
import { SEGMENT_LABEL } from '../trees/nodeSegment';
import './fitStars.css';

const STARS: Record<string, number> = {
  'very good': 3,
  good: 2,
  medium: 1,
  low: 0,
};

export default function FitStars({
  segment,
  title,
}: {
  segment: string;
  /** Overrides the tooltip, for callers with something to add to the label. */
  title?: string;
}) {
  const label = SEGMENT_LABEL[segment as Threshold] ?? segment;
  const count = STARS[segment];

  // An unknown segment shows nothing. Inventing a rating for it would be the
  // one failure mode that cannot be spotted by looking, and the mqa vocabulary
  // (high, very high) lands here.
  if (count === undefined) return null;

  return (
    <span className="fits" title={title ?? label}>
      <span aria-hidden="true">{count ? '⭐'.repeat(count) : '❌'}</span>
      <span className="fits-sr">{label}</span>
    </span>
  );
}
